(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account"]) return;
  try {
    
  jQuery(document).ready(function ($) {
    $('.tabs .tablinks').on('click', function () {
      let data_order_type = $(this).data('order-type');

      $('.tabs button').removeClass('active');
      $(this).toggleClass('active');

      $('.orders').removeClass('active');
      $('#' + data_order_type).toggleClass('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs-with-image"] && !Shopify.designMode) return;
  try {
    
    jQuery(document).ready(function($) {
        $('.faq-heading').on('click', function() {
            $('.faq').each(function(index) {
                const heading = $(this).find('.faq-heading');
                const content = $(this).find('.faq-content');

                if (!heading.is($(event.currentTarget))) {
                    heading.removeClass('active');
                    content.slideUp(400);
                }
            });

            $(this).toggleClass('active');

            const content = $(this).siblings('.faq-content');
            content.slideToggle(400);
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
    jQuery(document).ready(function($) {
        $('.faq-heading').on('click', function() {
            $('.faq').each(function(index) {
                const heading = $(this).find('.faq-heading');
                const content = $(this).find('.faq-content');

                if (!heading.is($(event.currentTarget))) {
                    heading.removeClass('active');
                    content.slideUp(400);
                }
            });

            $(this).toggleClass('active');

            const content = $(this).siblings('.faq-content');
            content.slideToggle(400);
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function($) {
    let marginLeftContainer = $('.header--root .header--wrapper').css('margin-left');

    $('.section--image-with-text .image-with-text--root[data-container-width="6"] .stacked-text--wrapper').css('margin-left', marginLeftContainer);

    $(window).on('resize', function() {
      let marginLeftContainer = $('.header--root .header--wrapper').css('margin-left');

      $('.section--image-with-text .image-with-text--root[data-container-width="6"] .stacked-text--wrapper').css('margin-left', marginLeftContainer);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
